import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe, PercentPipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CardComponent } from './card/card.component';
import { CustomPaginatorIntl } from './custom-paginator-intl';
import { InputComponent } from './input/input.component';
import { PaginationComponent } from './pagination/pagination.component';
import { PopUpComponent } from './pop-up/pop-up.component';
import { SelectComponent } from './select/select.component';
import { CustomActionComponent } from './table/_component/custom-action/custom-action.component';
import { CustomColumnComponent } from './table/_component/custom-column/custom-column.component';
import { TableComponent } from './table/table.component';

@NgModule({
    declarations: [
        BreadcrumbComponent,
        CardComponent,
        CustomActionComponent,
        CustomColumnComponent,
        InputComponent,
        PaginationComponent,
        PopUpComponent,
        SelectComponent,
        TableComponent
    ],
    imports: [
        RouterLink,
        RouterLinkActive,

        CommonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        MatTooltipModule,
        MatSortModule,
        ReactiveFormsModule,
        TranslateModule.forChild()
    ],
    exports: [
        BreadcrumbComponent,
        CardComponent,
        CustomActionComponent,
        CustomColumnComponent,
        InputComponent,
        PaginationComponent,
        PopUpComponent,
        SelectComponent,
        TableComponent,

        CurrencyPipe,
        DatePipe,
        DecimalPipe,
        PercentPipe,
        TitleCasePipe,
        TranslatePipe,

        MatButtonToggleModule,
        MatInputModule,
        MatSelectModule,
        MatSortModule,
        MatTableModule,
        ReactiveFormsModule
    ],
    providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }]
})
export class SharedModule {}
